// extracted by mini-css-extract-plugin
module.exports = {"alertRoot":"PaymentLockAlert_alertRoot__jC4oL"};